import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import { MultipleRESTService } from '../../../../src/app/API/apiService';
import {ApplicationModel, UserApplicationModel} from './application.model';
import {tap} from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ApplicationsApiService extends ReactiveServiceWithFilters  implements MultipleRESTService<ApplicationModel[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/' + 'application';
  protected userApplicationUrl = environment.backEndUrlPrefix + '/' + 'user_application';

  private _config?: ApplicationModel[] = undefined;
  get config(): ApplicationModel[] {
    return this._config;
  }
  constructor(protected http: HttpClient) {
    super();
  }

  getAll(): Observable<ApplicationModel[]> {
    return this.http.get<ApplicationModel[]>(this.buildUrl(this.baseUrl)).pipe(tap(cfg => this._config = cfg));
  }
  getAllWithCache(): Observable<ApplicationModel[]> {
    if (this._config) {
      return of<ApplicationModel[]>(this._config);
    }
    return this.getAll();
  }

  getUserApplication(): Observable<UserApplicationModel[]> {
    return  this.http.get<UserApplicationModel[]>(this.buildUrl(this.userApplicationUrl));
  }
  crateUserApplication(userApplication: UserApplicationModel): Observable<UserApplicationModel> {
    return  this.http.post<UserApplicationModel>(this.buildUrl(this.userApplicationUrl), userApplication);
  }
  updateUserApplication(userApplication: UserApplicationModel): Observable<UserApplicationModel> {
    return  this.http.put<UserApplicationModel>(`${this.userApplicationUrl}/${userApplication.id}`, userApplication);
  }

  updateGroup(ids: number[], data): Observable<ApplicationModel[]> {
    return this.http.patch<ApplicationModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApplicationModel[]> | Promise<ApplicationModel[]> | ApplicationModel[] {
    return this.getAll();
  }

}
